//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDateFullYear } from '@/helpers/filters';
export default {
  props: ['videos', 'currentVideo'],
  computed: {},
  methods: {
    formatDateFullYear,
    handleBgClick(event, resource) {
      if (resource.product === 'paid' && resource.status === 'planned') {
        event.preventDefault();
      }
    },
    handlePlayClick(event, resource) {
      if (resource.id === this.currentVideo.id) {
        event.preventDefault();
      }
    },
  },
};
